import { useContext, useEffect } from 'react';

import { useDatadogContext } from '@/context/hooks/useDatadogContext';

import { LogPageContext, LogPageContextType } from './LogPageContext';

// note: memoize the context to avoid logging on every render
export const usePageTracking = (manualContext?: LogPageContextType) => {
  const { datadogLogs } = useDatadogContext();
  const pageContext = useContext(LogPageContext);
  const [page, metadata] = pageContext ?? manualContext ?? [];
  useEffect(() => {
    if (!page) {
      return;
    }
    const startTime = Date.now();

    // Log the page visit
    datadogLogs?.logger?.log('page_visit', {
      page,
      action: 'enter',
      timestamp: startTime,
      ...(metadata ? metadata : {}),
    });

    return () => {
      const duration = Date.now() - startTime;

      // Log the duration of the page visit
      datadogLogs?.logger?.log('page_leave', {
        page,
        action: 'leave',
        duration,
        timestamp: Date.now(),
        ...(metadata ? metadata : {}),
      });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, datadogLogs]);
};
